var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "main-container",
      class: _vm.colorMode === "dark" ? "dark-block" : "",
    },
    [
      _c("h2", [
        _vm._v(
          "Does your work contribute to Africa's sustainable development?"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Investors are increasingly using ESG measures to inform their investment strategy. Our Virtual Deal Room partners use the platform to engage with companies making a positive impact on Africa's sustainable development through projects that support the built environment, climate change and health outcomes.\n  "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "action-wrap" }, [
        _c(
          "a",
          {
            staticClass: "cta-button",
            class: _vm.colorMode === "light" ? "medium-button" : "",
            on: { click: _vm.openLink },
          },
          [_vm._v("Opportunities for African Businesses")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }